import type { InferResponseType } from 'hono/client'
import type { AppType } from '@/api/index'
import { hc } from 'hono/client'

const API_BASE_URL = 'https://odds.nxtbets.com'
// const API_BASE_URL = 'http://localhost:3000'

// Create the Hono client with your API type
export const client = hc<AppType>(API_BASE_URL)

// Extract the API response type - need to await the promise to get the actual response
type EventsResponse = InferResponseType<typeof client.api.v1.events.$get, 200>

export type EventResponseData = EventsResponse['data']
export type EventMarkets = EventResponseData[number]

export type FanDuelSelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['FanDuel']
>['selectionData']

export type DraftKingsSelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['DraftKings']
>['selectionData']

export type Bet365SelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['Bet365']
>['selectionData']

export type BetMGMSelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['BetMGM']
>['selectionData']
